module.exports = __webpack_public_path__ + "static/media/img_group_null.c43ffc09.svg";